import React from 'react'
import UserRoles from '../../admin/UserRoles'
import V3DataRouteShell from '../data/V3DataRouteShell'

export default function V3UserRolesPage() {
  return (
    <V3DataRouteShell>
      <UserRoles />
    </V3DataRouteShell>
  )
}

